import { EmojiUtils } from 'src/utils/emoji';

import { EmojiProps } from './emoji.types';
import { Icon } from './emoji.styles';

const Emoji = ({ id, className, size = '1rem' }: EmojiProps) => {
  const native = EmojiUtils.convertEmojiCodeReceive(id);

  if (native) {
    return (
      <Icon data-test={native} className="_text-4">
        {native}
      </Icon>
    );
  }

  const unifiedToNative = EmojiUtils.getNativeFromUnified(id);

  if (unifiedToNative) {
    return (
      <Icon data-test="unified-to-native" className="_text-4">
        {unifiedToNative}
      </Icon>
    );
  }

  return <em-emoji data-test={id} id={id} size={size} class={className}></em-emoji>;
};

export default Emoji;
